import React, { useState } from "react";
import RequestService from "../../services/request.service";

// // import { Modal, Row, Form, Button, Col, InputGroup } from 'react-bootstrap'
import { Form } from 'react-bootstrap'

// import { Formik } from 'formik';
// import * as yup from 'yup';
import '../Reportes/mi_reporte.scss';


import { toast } from 'react-toastify'


// import { confirm } from '../../widgets/confirm'

// // // import './solicitudes.scss';

import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';

import moment from 'moment'
import 'moment/locale/es';


// import { SERVER_ } from  '../../config';
import { useParams } from 'react-router-dom'



import ReporteMensual from './Modales/ReporteMensual'
import ConfigurarMetasSucursales from './Modales/configurarMetasSucursales'


import ListaTramiteGerente from './Modales/ListaTramiteGerente'
import ListaTramiteAsesor from './Modales/ListaTramiteAsesor'


const ReporteUsuarios = () =>{

  let { uuid_sucursal } = useParams();

registerLocale('es', es)

  const [ cargando_noticia, setCargandoNoticia ] = useState( true )
  // const [ noticias, setNoticias ] = useState([])

  var [fecha,setFecha] = useState<any>( moment().format('YYYY-MM-DD') )


  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());


  const [startDate_, setStartDate_] = useState(new Date());
  const [endDate_, setEndDate_] = useState(new Date());





  // const onChang = (date:any)=>{
  //   // let DATE = (moment(date).format('YYYY-MM-DD')) //.toString()

  //   setFecha( moment(date).format('YYYY-MM-DD') )
  //   cargarMiReporte()
  // }



  const [ reporte, setReporte ] = useState<any>({
    sucursal : {
      nombre_sucursal : ""
    }
  })

  const cargarMiReporte = async()=>{
    try{
      setCargandoNoticia(true)
      // var uuid_sucursal = "mmm"
      var ED = endDate ? moment(endDate).format('YYYY-MM-DD') : null
      let response = await RequestService.getEndPoint('reporte-asociados/'+uuid_sucursal+'/'+moment(startDate).format('YYYY-MM-DD')+'/'+ ED)
      setReporte(response.data)
      setCargandoNoticia(false)

      setStartDate_(startDate)
      setEndDate_(endDate)
      // toast.success('La lista de Tramites del día '+fecha+' fue cargada')
    }
    catch(e){
      setCargandoNoticia(false)
      toast.error('Problemas al intentar generar tu reporte. Contacta con los administradores del sistema')
    }
  }


  React.useEffect(() => {
    cargarMiReporte()
  }, []);


  const mesDeLaFecha = date => {
    var mes = moment(date).format('MMMM')
    mes = mes.charAt(0).toUpperCase() + mes.slice(1) + ' del Año '+  moment(date).format('YYYY')
    return mes
  }

  const numeroSemanaDeLaFecha = date => (moment( date).isoWeek()+1)


  const [showModalReporteMensual, setShowModalReporteMensual] = useState(false);
  // const [  fechaReporte, setFechaReporte ] = useState("");
  // const [  yearReporte, setYearReporte ] = useState("");

  const openReporteMensualModal = (fecha:string) =>{
    setShowModalReporteMensual(true)
    // setFechaReporte(fecha)
  }
  const handleCloseReporteMensual = () =>{
    setShowModalReporteMensual(false)
  }




  const [showModalMetas, setShowModalMetaMensual] = useState(false);
  // const [  fechaReporte, setFechaReporte ] = useState("");
  // const [  yearReporte, setYearReporte ] = useState("");

  const openReporteMetaModal = (fecha:string) =>{
    setShowModalMetaMensual(true)
    // setFechaReporte(fecha)
  }
  const handleCloseMetaMensual = () =>{
    setShowModalMetaMensual(false)
  }

  const onChangeRango = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    // cargarMiReporte()
  };



  // <ListaTramiteGerente uuid_gerente={uuid_gerente_seleccionado} fecha_inicio={startDate_} fecha_fin={endDate_} show={showModalListaGerente} handleClose={handleCloseCaratulaModal} />

  const [ showModalListaGerente, setShowModalListaGerente ] = useState<boolean>(false)
  const [ uuid_gerente_seleccionado, setUUIDGerente_seleccionado ] = useState<string>('')
  const verDetalleGerente = (uuid_gerente:string)=>{
    setUUIDGerente_seleccionado(uuid_gerente)
    setShowModalListaGerente(true)
  }

  const handleCloseCaratulaModal = () =>{
    setShowModalListaGerente(false)
  }

  const [ showModalListaAsesor, setShowModalListaAsesor ] = useState<boolean>(false)
  // const [ uuid_gerente_seleccionado, setUUIDGerente_seleccionado ] = useState<string>('')
  const verDetalleAsesor = (uuid_gerente:string)=>{
    setUUIDGerente_seleccionado(uuid_gerente)
    setShowModalListaAsesor(true)
  }

  const handleCloseListaAsesorModal = () =>{
    setShowModalListaAsesor(false)
  }



  const descargarReporte = async() => {
    let res = await RequestService.downloadFile('mesa_atencion/excel/'+moment(startDate).format('YYYY-MM-DD')+'/'+moment(endDate).format('YYYY-MM-DD'))
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${Date.now()}.xlsx`);
    document.body.appendChild(link);
    link.click();
  }


  const [ arreglo_estatus, setEstatus ] = useState<any>([true,true,true,true,true,true,true,true,true,true])


  const todos = () =>{
    setEstatus([true,true,true,true,true,true,true,true,true,true])
  }
  const ninguno = () =>{
    setEstatus([false,false,false,false,false,false,false,false,false,false])
  }



      return (
             
          <>
              <div className="container">
                  
                  <h2>Reporte de Tramites Realizados</h2>

                <h3>
                  {reporte.sucursal.nombre_sucursal} 
                  <small className="text-muted"> {reporte.sucursal.uuid}</small>
                </h3>
                <hr />


                  <div className="row">
                    <div className="col-md-2">


                        <h5>Fecha de filtro</h5>


                        <div className="text-center">
                          <DatePicker
                            onChange={onChangeRango}
                            startDate={startDate}
                            endDate={endDate}
                            locale="es"
                            selectsRange
                            inline
                          />
                        </div>


                        <p className="text-center">
                          <button type="button" onClick={cargarMiReporte} className="btn btn-primary btn-sm">Aplicar Filtro <i className="fa fa-filter" /></button>
                        </p>




                



                    </div>
                    <div className="col-md-10">





                          {  (!cargando_noticia && reporte.hay_reporte ) && (

                              <>

                                  <h4 className="nm-">
                                    {
                                      moment(startDate_).format('YYYY-MM-DD') !== moment(endDate_).format('YYYY-MM-DD') && ('REPORTE ENTRE '+ moment(startDate_).format('DD [DE] MMMM [DEL] YYYY').toUpperCase() + ' Y EL ' + moment(endDate_).format('DD [DE] MMMM [DEL] YYYY').toUpperCase() )
                                    }
                                    {
                                      moment(startDate_).format('YYYY-MM-DD') === moment(endDate_).format('YYYY-MM-DD') && ('REPORTE PARA EL '+moment(startDate_).format('DD [DE] MMMM [DEL] YYYY').toUpperCase())
                                    }
                                  </h4>




                              <div className="row">
                                  
                                  <div className="col">
                                    
                                      <div key={`inline-checkbox`} className="">

                                      {
                                        // JSON.stringify(arreglo_estatus)
                                      }


                                        <Form.Check
                                          inline
                                          name="group1"
                                          type="checkbox"
                                          label="CAPTURA"
                                          checked={arreglo_estatus[0]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[0] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_1`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group2"
                                          type="checkbox"
                                          label="MESA DE ATENCIÓN"
                                          checked={arreglo_estatus[1]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[1] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_2`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group3"
                                          type="checkbox"
                                          label="RECTIFICACIÓN"
                                          checked={arreglo_estatus[2]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[2] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_3`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group4"
                                          type="checkbox"
                                          label="VERIFICACIÓN TELEFÓNICA"
                                          checked={arreglo_estatus[3]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[3] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_4`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group5"
                                          type="checkbox"
                                          label="ASEGURAMIENTO"
                                          checked={arreglo_estatus[4]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[4] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_5`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group6"
                                          type="checkbox"
                                          label="PRODUCCIÓN ACEPTADA"
                                          checked={arreglo_estatus[5]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[5] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_6`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group7"
                                          type="checkbox"
                                          label="POR COBRAR"
                                          checked={arreglo_estatus[6]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[6] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_7`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group8"
                                          type="checkbox"
                                          label="LIQUIDADO"
                                          checked={arreglo_estatus[7]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[7] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_8`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group10"
                                          type="checkbox"
                                          label="CANCELADO"
                                          checked={arreglo_estatus[8]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[8] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_10`}
                                        />


                                        <Form.Check
                                          inline
                                          name="group9"
                                          type="checkbox"
                                          label="PENALIZADO"
                                          checked={arreglo_estatus[9]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[9] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_9`}
                                        />

                                        
                                      </div>

                                    <ul className="list-inline">
                                      <li className="list-inline-item"><small className="cursor" onClick={()=>{todos()}}>Todos</small> / <small className="cursor" onClick={()=>{ninguno()}}>Ninguno</small></li>
                                      <li className="list-inline-item"><button type="button" onClick={()=>{descargarReporte()}} className="btn btn-sm btn-link">Descargar <i className="fa fa-file-excel-o" /></button></li>
                                    </ul>

                                      <p className="mb-3">
                                        
                                      </p>

                                  </div>

                              </div>






                                  <hr />

                                  {
                                    // JSON.stringify(reporte.estatus)
                                  }


                                    <table className="table">
                                      <thead style={{"fontSize":8}}>
                                        <tr>
                                          <th scope="col">Gerente</th>
                                          <th scope="col">Total de Tramites</th>


                                            { arreglo_estatus[0] && ( <th scope="col" className={'estatus_1 v text-center'}>En captura</th> ) }
                                            { arreglo_estatus[1] && ( <th scope="col" className={'estatus_2 v text-center'}>Mesa de atención</th> )}
                                            { arreglo_estatus[2] && ( <th scope="col" className={'estatus_3 v text-center'}>Retificación</th> )}
                                            { arreglo_estatus[3] && ( <th scope="col" className={'estatus_8 v text-center'}>Verificación telefónica</th> )}
                                            { arreglo_estatus[4] && ( <th scope="col" className={'estatus_4 v text-center'}>Aseguramiento</th> )}
                                            { arreglo_estatus[5] && ( <th scope="col" className={'estatus_9 v text-center'}>Producción aceptada</th> )}
                                            { arreglo_estatus[6] && ( <th scope="col" className={'estatus_5 v text-center'}>Por cobrar</th> )}
                                            { arreglo_estatus[7] && ( <th scope="col" className={'estatus_6 v text-center'}>Liquidado</th> )}
                                            { arreglo_estatus[8] && ( <th scope="col" className={'estatus_999 v text-center'}>Cancelado</th> )}
                                            { arreglo_estatus[9] && ( <th scope="col" className={'estatus_7 v text-center'}>Penalizado</th> )}

                                          {
                                            // reporte.estatus.map(estatus =>

                                            //     <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                            //       <th scope="col" className={'estatus_'+(estatus.id)+' v text-center'}>
                                            //         {estatus.estatus}
                                            //       </th>
                                            //     </React.Fragment>

                                            // )
                                          }

                                        </tr>
                                      </thead>
                                      <tbody>

                                        {
                                          reporte.RowsAcumulados.map( asociado => 

                                              <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>

                                              {
                                                asociado.total > 0 && (

                                                  <React.Fragment>

                                                      <tr className="table-primary" key={ Math.random().toString(36).substr(2, 9) }>
                                                        <td className="v" style={{fontSize:14}}><b>{asociado.nombres}</b> <small>{asociado.paterno} {asociado.materno}</small></td>
                                                        <td className="v text-center"><b className="cursor" onClick={()=>{verDetalleGerente(asociado.uuid)}}>{asociado.total}</b></td>




                                                        { arreglo_estatus[0] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_captura}</b></td> )}
                                                        { arreglo_estatus[1] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_mesa}</b></td> )}
                                                        { arreglo_estatus[2] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_rectificacion}</b></td> )}
                                                        { arreglo_estatus[3] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_verificacion_telefonica}</b></td> )}
                                                        { arreglo_estatus[4] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_aseguramiento}</b></td> )}
                                                        { arreglo_estatus[5] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_verificacion_final}</b></td> )}
                                                        { arreglo_estatus[6] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_sin_pagar}</b></td> )}
                                                        { arreglo_estatus[7] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_liquidado}</b></td> )}
                                                        { arreglo_estatus[8] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_canceladas}</b></td> )}
                                                        { arreglo_estatus[9] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_penalizado}</b></td> )}


                                                      </tr>

                                                {
                                                  asociado.asesores.map( asesor =>


                                                    
                                                      <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                        <td className="v" style={{fontSize:12}}><b>{asesor.nombres}</b> <small>{asesor.paterno} {asesor.materno}</small></td>
                                                        <td className="v text-center"><b className="cursor" onClick={()=>{verDetalleAsesor(asesor.uuid)}}><small>{asesor.total}</small></b></td>

                                                        { arreglo_estatus[0] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_captura}</b></td> )}
                                                        { arreglo_estatus[1] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_mesa}</b></td> )}
                                                        { arreglo_estatus[2] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_rectificacion}</b></td> )}
                                                        { arreglo_estatus[3] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_verificacion_telefonica}</b></td> )}
                                                        { arreglo_estatus[4] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_aseguramiento}</b></td> )}
                                                        { arreglo_estatus[5] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_verificacion_final}</b></td> )}
                                                        { arreglo_estatus[6] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_sin_pagar}</b></td> )}
                                                        { arreglo_estatus[7] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_liquidado}</b></td> )}
                                                        { arreglo_estatus[8] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_canceladas}</b></td> )}
                                                        { arreglo_estatus[9] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_penalizado}</b></td> )}



                                                      </tr>


                                                  )
                                                }

                                                  </React.Fragment> 


                                                )
                                              }
                                              

                                              </React.Fragment>

                                            )
                                        }

                                      </tbody>
                                    </table>
                                    

{
                                    // <table className="table">
                                    //   <thead style={{"fontSize":8}}>
                                    //     <tr>
                                    //       <th scope="col"></th>
                                    //       <th scope="col">Celular</th>
                                    //       <th scope="col">Nombre(s)</th>
                                    //       <th scope="col">Apellido Paterno</th>
                                    //       <th scope="col">Apellido Materno</th>
                                    //       <th scope="col">Total de Tramites</th>
                                    //     </tr>
                                    //   </thead>
                                    //   <tbody>
                                    //   {
                                    //     reporte.RowsAcumulados.map( asociado => 
                                    //           <tr key={asociado.id}>
                                    //             <th className="v" scope="row">
                                    //             {(asociado.rol==="ROLE_ASESOR" &&(<p className="nm">ASESOR</p>))}
                                    //             {(asociado.rol==="ROLE_GERENTE" &&(<p className="nm">GERENTE</p>))}
                                    //             </th>
                                    //             <td className="v"><small>{asociado.celular}</small></td>
                                    //             <td className="v"><small>{asociado.nombres}</small></td>
                                    //             <td className="v"><small>{asociado.paterno}</small></td>
                                    //             <td className="v"><small>{asociado.materno}</small></td>
                                    //             <td className="v text-right"><b>{asociado.total}</b></td>
                                    //           </tr>
                                    //       )
                                    //   }

                                    //   </tbody>
                                    // </table>
                                    }

                              </>

                           )}

                          {  cargando_noticia && (

                              <>
                                <div className="loader">
                                  <div className="loaderBar"></div>
                                </div>
                              </>


                           )}

                          { (!cargando_noticia && !reporte.hay_reporte) && (


                              <div className="alert alert-dismissible alert-warning">
                                <h4 className="alert-heading">...</h4>
                                <p className="mb-0">No tenemos reporte para este día</p>
                              </div>


                           )}


                    </div>
                  </div>


              </div>






<ReporteMensual fecha_reporte={fecha} showModalReporteMensual={showModalReporteMensual} uuid_sucursal={uuid_sucursal} handleClose={handleCloseReporteMensual} />



<ConfigurarMetasSucursales fecha_reporte={fecha} showModalMetas={showModalMetas} uuid_sucursal={uuid_sucursal} handleClose={handleCloseMetaMensual} />





                {
                  showModalListaGerente && (

                      <ListaTramiteGerente uuid_gerente={uuid_gerente_seleccionado} fecha_inicio={startDate_} fecha_fin={endDate_} show={showModalListaGerente} handleClose={handleCloseCaratulaModal} />

                  )

                }


                {
                  showModalListaAsesor && (

                      <ListaTramiteAsesor uuid_asesor={uuid_gerente_seleccionado} fecha_inicio={startDate_} fecha_fin={endDate_} show={showModalListaAsesor} handleClose={handleCloseListaAsesorModal} />

                  )

                }







          </>


            








      );
  

}

export default ReporteUsuarios
